export const defaultSummaryTVLs = {
  summaryTVL: '0',
  takerTVL: '0',
  makerTVL: '0',
  stakerTVL: '0',
};
